import CircleIcon from '@mui/icons-material/Circle';

import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { SimplePaletteColorOptions, Theme, useTheme } from '@mui/material';
import { ScanPipelineStatuses } from '../../../../services/entities/impl/blfApi/schemas/scan';

type UseScanStatusIndicatorReturn = {
  shortDescription?: string;
  longDescription?: string;
  color: SimplePaletteColorOptions;
  isSupported?: boolean;
  icon: typeof TimerOutlinedIcon;
};
export const useScanStatusIndicator = (
  status: ScanPipelineStatuses | null
): UseScanStatusIndicatorReturn => {
  const theme = useTheme();
  if (!isSupportedScanStatus(status))
    return {
      color: theme.palette.primary,
      isSupported: false,
      icon: CircleIcon,
    };

  const statusColor = getScanStatusColor(status, theme);
  const statusTooltip = ScanStatusLongDescMap[status] ?? '';

  return {
    shortDescription: status,
    longDescription: statusTooltip,
    color: statusColor,
    isSupported: true,
    icon: TimerOutlinedIcon,
  };
};

export function isSupportedScanStatus(
  status: ScanPipelineStatuses | null
): status is SupportedScanStatus {
  const supportedStatus: Record<ScanPipelineStatuses, boolean> = {
    'In Progress': true,
    Pending: false,
    Completed: false,
    'Completed With Errors': false,
    Error: false,
    Uploading: false,
  };
  return !!status && supportedStatus[status];
}

/**
 * Subset of ScanPipelineStatuses
 */
type SupportedScanStatus = 'In Progress';

const ScanStatusLongDescMap: Record<SupportedScanStatus, string> = {
  ['In Progress']: 'Files Uploaded, AI Analysis in Progress',
};

export const getScanStatusColor = (
  scanStatus: SupportedScanStatus,
  theme: Theme
): SimplePaletteColorOptions => {
  switch (scanStatus) {
    case 'In Progress':
      return {
        main: theme.colors.common.softWhite,
      };

    default:
      return theme.palette.primary;
  }
};
